import { OnboardingStep } from '../types'

type OnboardingSteps = {
  [K in
    | 'step1'
    | 'step2'
    | 'step3'
    | 'step4'
    | 'step5'
    | 'step6'
    | 'step7']: OnboardingStep
}

/** Common translation keys for usage across the onboarding steps */
export const TRANSLATION_KEYS = {
  selectOption: 'onboarding_questionnaire_select',
  radioGroupHeading: 'onboarding_questionnaire_select_option',
  skipButton: 'skip',
  backButton: 'back',
  doneButton: 'done_button',
  other: 'other_industry',
  continueButton: 'continue_button',
  inputLabel: 'onboarding_questionnaire_specify',
} as const

/** Specific step configuration for the onboarding steps */
export const ONBOARDING_STEPS: OnboardingSteps = {
  step1: {
    id: 'step1',
    title: 'welcome_to_ubesuggest',
    description: 'onboarding_questionnaire_step1',
    ctaButton: 'get_started',
    order: 1,
  },
  step2: {
    id: 'step2',
    title: 'onboarding_questionnaire_step2',
    order: 2,
  },
  step3: {
    id: 'step3',
    title: 'onboarding_questionnaire_step3',
    order: 3,
  },
  step4: {
    id: 'step4',
    title: 'onboarding_questionnaire_step4',
    order: 4,
  },
  step5: {
    id: 'step5',
    title: 'onboarding_questionnaire_step5',
    order: 5,
  },
  step6: {
    id: 'step6',
    title: 'onboarding_questionnaire_step6',
    order: 6,
  },
  step7: {
    id: 'step7',
    title: 'help_form_success_heading',
    description: 'onboarding_questionnaire_sucess_step_diy',
    order: 7,
  },
} as const

export type OnboardingStepKeys = keyof typeof ONBOARDING_STEPS
